/* eslint-disable no-unused-vars */
import { FilesActionTypes, FilesMutationTypes } from './types';

export const actions = {
    async [FilesActionTypes.GetFiles]({ commit }, { params }) {
        try {
            const { data } = await this.$api.getFiles.get({
                params: { ...params }
            })

            commit(FilesMutationTypes.SetFiles, {files: data.data.data})
        } catch (error) {
            console.log('---error 2', error)
        }
    },
    async [FilesActionTypes.AddFile]({ commit }, { files }) {
        try {
            const { data } = await this.$api.addFile.post({ 
                body: files, 
                headers: { "Content-Type":"multipart/form-data" } 
            })
            
            commit(FilesMutationTypes.SetFiles, {file: data.data})
        } catch (error) {
            console.log('---error 1', error)
        }
    },
}